import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import {  SubNavbarComponent } from './subnavbar/subnavbar.component';
import { SubFooterComponent } from './subfooter/subfooter.component';
import {MatMenuModule} from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule
  ],
  declarations: [
    SubFooterComponent,
    SubNavbarComponent
  ],
  exports: [
    SubFooterComponent,
    SubNavbarComponent,
    MatMenuModule
  ]
})
export class SubComponentsModule { }
